import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AuthContext from "../../../../context/auth/authContext";
import Modulos from "../../../general/screen/Modulos";
import EcosistemaTitulo from "../../ecosistemas/EcosistemaTitulo";
import HomeInUser from "../../principal/components/HomeInUser";
import ValorFacturaCards from "../components/ValorFacturaCards"
import useTitle from "../../../hooks/useTitle";

const ValorFacturaScreen = () => {
  useTitle({ title: "Detalle Ecosistema Protección Financiera" });
  const { pathname } = useLocation();
  const { globalActualizarEcosistemaActivo } = useContext(AuthContext);

  useEffect(() => {
    if (pathname === "/ecosistema/valor-factura") {
      globalActualizarEcosistemaActivo(15);
    }
  }, []);

  return (
    <div className="homein">
      <EcosistemaTitulo />

      <div className="homein__resumen">
        <HomeInUser id={15} />
      </div>

      <div className="homein__detalle">
        <Modulos />
        <ValorFacturaCards />
      </div>
    </div>
  );
};

export default ValorFacturaScreen;
